import { Stack, Text } from '@fluentui/react';
import AreaDirectorySkeleton from 'components/AreaDirectorySkeleton/AreaDirectorySkeleton';
import { IC } from 'components/SVGIcon';
import { AreaWarning } from 'kits/IconKit2';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';

const AllAreasDeleted: React.FC<{ isEligibleToCreateAreas: boolean; isAreaDirectoryLoading: boolean; compact?: boolean }> = ({
    isEligibleToCreateAreas,
    isAreaDirectoryLoading,
    compact
}) => {
    return (
        <Stack horizontal verticalAlign="center" horizontalAlign="center" style={{ width: '100%', height: '100%' }}>
            {isAreaDirectoryLoading ? (
                <AreaDirectorySkeleton compact={compact} />
            ) : (
                <Stack
                    styles={{
                        root: {
                            width: '500px',
                            height: '250px',
                            textAlign: 'center',
                            padding: '20px',
                            background: '#fff',
                            borderRadius: '10px'
                        }
                    }}
                >
                    <Stack tokens={{ childrenGap: 40 }}>
                        <Stack style={{ marginTop: '20px' }}>
                            <IC variant={'custom'} size={50}>
                                <AreaWarning />
                            </IC>
                        </Stack>

                        <Stack verticalAlign="center" horizontalAlign="center" tokens={{ childrenGap: 16 }} style={{ marginTop: '50px' }}>
                            <Text variant="large" block style={{ fontWeight: 'bold' }}>
                                {IvicosStrings.allAreasDeletedPart1}
                            </Text>
                            {isEligibleToCreateAreas && (
                                <Text variant="large" block style={{ fontWeight: 'bold' }}>
                                    {IvicosStrings.allAreasDeletedPart2}
                                </Text>
                            )}
                        </Stack>
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};

export default AllAreasDeleted;
